import ApiBase from '../ApiBase';

class Chats extends ApiBase {
    route = '/networking/chats';

    /**
     * @returns {Promise<*>}
     */
    getNumberUnread = () => {
        return this.get(this.route + '/number-unread');
    };

    /**
     * @param {string} message_to_type
     * @param {string} message_to_id
     * @param {string} message
     * @returns {Promise<*>}
     */
    postMessage = (message_to_type, message_to_id, message) => {
        return this.post(this.route, {
            message_to_type,
            message_to_id,
            message
        });
    };

    /**
     * @param {string} message_to_type
     * @param {string} message_to_id
     * @param {integer} page
     * @returns {Promise<*>}
     */
    getChat = (message_to_type, message_to_id, page) => {
        return this.get(this.route + '/' + message_to_id, {
            page,
            message_to_type
        });
    };
}

export default new Chats;
